import luckysheetMoreFormat from "../moreFormat"

const echoFns = {
    automatic() {
        // 自动

    },
    text() {
        // 文本
    },
    num(curCell) {
        // 数字
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }

        if (fa.includes('#,')) {
            // 千分位
            $('#numSepa').prop('checked', true)
        }
        if (fa.split('.')?.[1]) {
            // 小数点
            $('#numDecimal').val(fa.split('.')?.[1].length)
        }


    },
    percent(curCell) {
        // 百分比
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }
        let str = fa.split('.')?.[1]
        if (str) {
            // 小数点
            str = str.replaceAll('%', '')
            $('#percentNumDecimal').val(str.length)
        }

    },
    sci(curCell) {
        // 科学计数
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }

        let str = fa.split('E+')[0]?.split('.')?.[1]
        if (str) {
            // 科学计数
            $('#sciNumDecimal').val(str.length)
        }

    },
    accounting(curCell) {
        // 会计计数
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }
        // ￥(0.00)
        let zeroStr = fa.split('.')?.[1]
        if (zeroStr) {
            zeroStr = zeroStr.split('').filter(i => i == '0')
            // 小数点
            $('#accountingNumDecimal').val(zeroStr.length)
        }

        $('#accountingList').find('.accountingItem').removeClass('curListItem')
        const t = fa.split('(')[0]
        const curDom = $('#accountingList').find(`.accountingItem[data-value="${t}"]`).first()
        if (curDom) {

            curDom.addClass('curListItem')
        }
    },
    currency(curCell) {
        // 货币计数
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }
        // ￥ 0.00
        let zeroStr = fa.split('.')?.[1]
        if (zeroStr) {
            zeroStr = zeroStr.split('').filter(i => i == '0')
            // 小数点
            $('#currencyNumDecimal').val(zeroStr.length)
        }

        $('#currencyList').find('.curListItem').removeClass('curListItem')
        const t = fa.split(' ')[0].replaceAll('"', '')
        const curDom = $('#currencyList').find(`.currencyItem[data-value=${t}]`).first()
        if (curDom) {
            curDom.addClass('curListItem')
        }
    },
    date(curCell) {
        // 日期
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }
        if (curCell?.ct?.t !== 'd') {
            return
        }

        const curDom = $('#fmtDateList').find(`.fmtDateItem[data-value="${encodeURIComponent(fa)}"]`)
        if (curDom) {
            $('#fmtDateList').find('.curListItem').removeClass('curListItem')
            curDom.addClass('curListItem')
        }

    },
    time(curCell) {
        // 时间
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }
        if (curCell?.ct?.t !== 'd') {
            return
        }

        const arr = luckysheetMoreFormat.sfmtTime
        const curDom = $('#fmtDateList').find(`.fmtDateItem[data-value="${encodeURIComponent(fa)}"]`)
        if (curDom) {
            $('#fmtDateList').find('.curListItem').removeClass('curListItem')
            curDom.addClass('curListItem')
        }
    },
    custom() {
        // 自定义
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }

        const curDom = $('#fmtDateList').find(`.fmtDateItem[data-value="${encodeURIComponent(fa)}"]`).first()
        if (curDom) {
            $('#fmtDateList').find('.curListItem').removeClass('curListItem')
            curDom.addClass('curListItem')
        }
    },
    special() {
        // 特殊
        const fa = curCell?.ct?.fa
        if (!fa) {
            return
        }

        const curDom = $('#fmtDateList').find(`.fmtDateItem[data-value="${encodeURIComponent(fa)}"]`)
        if (curDom) {
            $('#fmtDateList').find('.curListItem').removeClass('curListItem')
            curDom.addClass('curListItem')
        }
    }
}
export default echoFns